var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessOfferCarom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,7A17,17 0,1 0,24,41A17,17 0,1 0,24,7",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,19m-4,0a4,4 0,1 0,8 0a4,4 0,1 0,-8 0",
    fill: "#00D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29,28m-4,0a4,4 0,1 0,8 0a4,4 0,1 0,-8 0",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18m-3,0a3,3 0,1 0,6 0a3,3 0,1 0,-6 0",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17,29c2.8,-4.1 7,-6.5 12.1,-6.9",
    fill: "#00000000",
    stroke: "#7C1CFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessOfferCarom);
export default __webpack_public_path__ + "static/media/p4r_business_offer_carom.b0c27c2eec793d30066e4c29bfdb2cd9.svg";
export { ForwardRef as ReactComponent };